export default class ItemStatusDomainService {
    static get NONE() {
        return 0;
    }
    static get PERSON_ALERT_CLOSED_ID() {
        return 1;
    }
    static get PERSON_ALERT_OPEN_ID() {
        return 2;
    }
    static get TRANSCRIPT_COURSE_WITHDRAWN_ID() {
        return 3;
    }
    static get TRANSCRIPT_COURSE_REGISTERED_ID() {
        return 4;
    }
    static get TRANSCRIPT_COURSE_DROPPED_ID() {
        return 5;
    }
    static get TRANSCRIPT_COURSE_WAITLISTED_ID() {
        return 6;
    }
    static get SURVEY_PENDING_ID() {
        return 8;
    }
    static get SURVEY_COMPLETED_ID() {
        return 9;
    }
    static get SURVEY_PARTIAL_ID() {
        return 10;
    }
    static get SURVEY_OVER_QUOTA_ID() {
        return 11;
    }
    static get SURVEY_DISQUALIFIED_ID() {
        return 12;
    }
    static get TASK_NOT_STARTED_ID() {
        return 13;
    }
    static get TASK_IN_PROGRESS_ID() {
        return 14;
    }
    static get TASK_COMPLETED_ID() {
        return 15;
    }
    static get TASK_CANCELLED_ID() {
        return 16;
    }
    static get MEETING_NOT_CANCELLED_ID() {
        return 17;
    }
    static get MEETING_CANCELLED_ID() {
        return 18;
    }
    static get ACADEMIC_PLAN_APPROVED() {
        return 19;
    }
    static get ACADEMIC_PLAN_NEW() {
        return 20;
    }
    static get ACADEMIC_PLAN_PENDING_ADVISOR() {
        return 21;
    }
    static get ACADEMIC_PLAN_PENDING_STUDENT() {
        return 22;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_PRESENT() {
        return 23;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_TARDY() {
        return 24;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_ABSENT() {
        return 25;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_ENTRY() {
        return 26;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_NO_ENTRY() {
        return 27;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_PRESENT_EXCUSED() {
        return 28;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_TARDY_EXCUSED() {
        return 30;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_ABSENT_EXCUSED() {
        return 29;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_ENTRY_EXCUSED() {
        return 31;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_NO_ENTRY_EXCUSED() {
        return 32;
    }
    static get TRANSCRIPT_COURSE_ATTENDANCE_UNKNOWN() {
        return 33;
    }
    static get TRANSCRIPT_COURSE_PURGED_BY_INSTITUTION_ID() {
        return 34;
    }
    static get TRANSCRIPT_COURSE_WITHDRAW_IN_PROGRESS_ID() {
        return 35;
    }
    static get TRANSCRIPT_COURSE_UNKNOWN_ID() {
        return 36;
    }
    static get TRANSCRIPT_COURSE_DELETED_ID() {
        return 37;
    }
    static get TRANSCRIPT_COURSE_WEB_WITHDRAWN_ID() {
        return 38;
    }
    static get NOT_STARTED_ID() {
        return 39;
    }
    static get IN_PROCESS_ID() {
        return 40;
    }
    static get COMPLETE_ID() {
        return 41;
    }
    static get CAMPAIGN_MESSAGE_SENT() {
        return 42;
    }
    static get CAMPAIGN_MESSAGE_DELIVERED() {
        return 43;
    }
    static get CAMPAIGN_MESSAGE_BOUNCED() {
        return 44;
    }
    static get CAMPAIGN_MESSAGE_OPENED() {
        return 45;
    }
    static get CAMPAIGN_MESSAGE_CLICKED() {
        return 46;
    }
    static get CAMPAIGN_MESSAGE_UNSENT() {
        return 47;
    }
    static getColor(statusId) {
        const defaultColor = "secondary";
        if (!statusId) {
            return defaultColor;
        }
        // Don't use light.  It blends in with the background too much.
        const colorMapping = {
            [ItemStatusDomainService.PERSON_ALERT_CLOSED_ID]: "secondary",
            [ItemStatusDomainService.PERSON_ALERT_OPEN_ID]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_WITHDRAWN_ID]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_REGISTERED_ID]: "success",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_DROPPED_ID]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_WAITLISTED_ID]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_PURGED_BY_INSTITUTION_ID]: "secondary",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_WITHDRAW_IN_PROGRESS_ID]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_UNKNOWN_ID]: "secondary",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_DELETED_ID]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_WEB_WITHDRAWN_ID]: "danger",
            [ItemStatusDomainService.SURVEY_PENDING_ID]: "dark",
            [ItemStatusDomainService.SURVEY_COMPLETED_ID]: "success",
            [ItemStatusDomainService.SURVEY_PARTIAL_ID]: "warning",
            [ItemStatusDomainService.SURVEY_OVER_QUOTA_ID]: "warning",
            [ItemStatusDomainService.SURVEY_DISQUALIFIED_ID]: "warning",
            [ItemStatusDomainService.TASK_NOT_STARTED_ID]: "dark",
            [ItemStatusDomainService.TASK_IN_PROGRESS_ID]: "info",
            [ItemStatusDomainService.TASK_COMPLETED_ID]: "success",
            [ItemStatusDomainService.TASK_CANCELLED_ID]: "danger",
            [ItemStatusDomainService.MEETING_NOT_CANCELLED_ID]: "secondary",
            [ItemStatusDomainService.MEETING_CANCELLED_ID]: "secondary",
            [ItemStatusDomainService.ACADEMIC_PLAN_APPROVED]: "success",
            [ItemStatusDomainService.ACADEMIC_PLAN_NEW]: "secondary",
            [ItemStatusDomainService.ACADEMIC_PLAN_PENDING_ADVISOR]: "secondary",
            [ItemStatusDomainService.ACADEMIC_PLAN_PENDING_STUDENT]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_PRESENT]: "success",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_TARDY]: "warning",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_ABSENT]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_ENTRY]: "secondary",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_NO_ENTRY]: "danger",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_PRESENT_EXCUSED]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_TARDY_EXCUSED]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_ABSENT_EXCUSED]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_ENTRY_EXCUSED]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_NO_ENTRY_EXCUSED]: "info",
            [ItemStatusDomainService.TRANSCRIPT_COURSE_ATTENDANCE_UNKNOWN]: "info",
            [ItemStatusDomainService.NOT_STARTED_ID]: "danger",
            [ItemStatusDomainService.IN_PROCESS_ID]: "warning",
            [ItemStatusDomainService.COMPLETE_ID]: "success",
            [ItemStatusDomainService.NONE]: "primary",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_SENT]: "secondary",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_DELIVERED]: "info",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED]: "danger",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_OPENED]: "success",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_CLICKED]: "success",
            [ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT]: "warning",
        };
        return colorMapping[statusId] || defaultColor;
    }
    /**
     * There's a hierarchy of statuses for campaign messages.  For example, if something is delivered, that means it
     * was also sent.  If something was opened, then it must have also been delivered, which means it was also sent.
     * This defines that hierarchy for other service methods.
     *
     * @returns {number[]} an array of statuses in hierarchical order
     */
    static getCampaignEmailStatusHierarchy() {
        return [
            ItemStatusDomainService.CAMPAIGN_MESSAGE_CLICKED,
            ItemStatusDomainService.CAMPAIGN_MESSAGE_OPENED,
            ItemStatusDomainService.CAMPAIGN_MESSAGE_DELIVERED,
            ItemStatusDomainService.CAMPAIGN_MESSAGE_SENT,
        ];
    }
    /**
     * There's a hierarchy of statuses for campaign messages.  For example, if something is delivered, that means it
     * was also sent.  If something was opened, then it must have also been delivered, which means it was also sent.
     * This method will, for example, when given the opened status, return the sent, delivered, and opened status.
     *
     * There are a couple special cases.  Bounced messages for example, can only be bounced (even though to become bounced
     * they must have been sent, it doesn't make sense to include sent messages in bounced lists).  Also, all messages
     * start with an "UN_SENT" status.  It doesn't make sense to include these messages in sent lists.
     *
     * @param {number} statusId - the status id
     * @returns {|number[]} - statuses that this message must have gone through to get to the current status
     */
    static campaignEmailStatusUpToAndIncluding(statusId) {
        if (statusId === ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED) {
            return [ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED];
        }
        if (statusId === ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT) {
            return [ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT];
        }
        const hierarchy = ItemStatusDomainService.getCampaignEmailStatusHierarchy();
        const index = hierarchy.findIndex((s) => s === statusId);
        return hierarchy.slice(0, index + 1);
    }
    /**
     * There's a hierarchy of statuses for campaign messages.  For example, if something is delivered, that means it
     * was also sent.  If something was opened, then it must have also been delivered, which means it was also sent.
     * This method returns all the messages that haven't gotten to or will not get to this status.  For example, when
     * given the opened status, this method returns the unsent, bounced, sent, and delivered statuses.  All these messages
     * haven't been opened yet (or will never be opened).
     *
     * @param {number} statusId - the status
     * @returns {number[]} - statuses that haven't reached the status yet or will never reach it.
     */
    static getNotCampaignEmailStatus(statusId) {
        if (statusId === ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED) {
            return ItemStatusDomainService.getCampaignEmailStatusHierarchy().concat([
                ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT,
                ItemStatusDomainService.NONE,
            ]);
        }
        if (statusId === ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT) {
            return ItemStatusDomainService.getCampaignEmailStatusHierarchy().concat([
                ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED,
                ItemStatusDomainService.NONE,
            ]);
        }
        const hierarchy = ItemStatusDomainService.getCampaignEmailStatusHierarchy();
        hierarchy.reverse();
        const index = hierarchy.findIndex((s) => s === statusId);
        if (index < 0) {
            return [];
        }
        return hierarchy
            .slice(0, index)
            .concat([
            ItemStatusDomainService.NONE,
            ItemStatusDomainService.CAMPAIGN_MESSAGE_BOUNCED,
            ItemStatusDomainService.CAMPAIGN_MESSAGE_UNSENT,
        ]);
    }
}
